<template>
  <validation-provider
    v-slot="{ valid, errors }"
    ref="validator"
    :vid="inputId"
    :name="$attrs.name"
    :rules="rules"
  >
    <b-form-group
      :id="inputId + '-group'"
      :label="label"
      :label-for="inputId"
    >
      <b-form-input
        :id="inputId"
        v-model="inputValue"
        :name="$attrs.name"
        :state="errors[0] ? false : (valid ? true : null)"
        type="text"
        size="sm"
        trim
      />
      <b-form-invalid-feedback id="inputLiveFeedback">
        {{ errors[0] }}
      </b-form-invalid-feedback>
    </b-form-group>
  </validation-provider>
</template>

<script>
import {ValidationProvider} from 'vee-validate';

export default {
  name: 'ValidatedTextInput',
  components: {ValidationProvider},
  props: {
    inputId: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    rules: {
      type: [Object, String],
      default: ''
    },
    value: {
      type: String,
      default: null
    }
  },
  data: () => ({
    inputValue: null
  }),
  watch: {
    inputValue(newVal) {
      this.$emit('input', newVal);
    },
    value(newVal) {
      this.inputValue = newVal;
    }
  },
  created() {
    if (this.value) {
      this.inputValue = this.value;
    }
  }
};
</script>
